// extracted by mini-css-extract-plugin
module.exports = {"section":"about_section__g4zM_","card":"about_card__KHJer","cardBody":"about_cardBody__YeJ14","cardImage":"about_cardImage__IbFUs","button":"about_button__PpKGo"};